import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useCalibrationStatus() {
  const { getCalibrationStatus } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["calibration-status"],
    queryFn: async () => {
      const response = await getCalibrationStatus();
      return (
        response?.data ?? { has_calibration: false, has_layout_image: false }
      );
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    hasCalibration: Boolean(data?.has_calibration),
    hasLayoutImage: Boolean(data?.has_layout_image),
    isLoading,
  };
}
